import Icon, { ErrorFillIcon } from '@design-systems/react-icons'
import { BoldText, CenterAlign, LostConnectionPopup } from './styles'
import { Button, Spinner } from '@design-systems/canvas-ui'
import { useState } from 'react'
import { getLocation } from '@praxis/runtime-utils/getLocation'

export const LostConnectionPopUp = (props) => {
  const [reconnectClicked, setReconnectClicked] = useState(0)

  const handleReloadPage = () => {
    const cookies = document.cookie.split(';')

    // set 1 Jan, 1970 expiry for every cookies
    for (let i = 0; i < cookies.length; i++) {
      document.cookie = cookies[i] + '=;expires=' + new Date(0).toUTCString()
    }
    const location = getLocation()
    location.reload()
  }

  const handleReconnectButton = () => {
    props.retryConnection()
    setReconnectClicked(reconnectClicked + 1)
  }

  return (
    <LostConnectionPopup expand={props.shouldExpand}>
      <CenterAlign className="display-flex hc8-mb-2x">
        {props.retryInProgress ? (
          <Spinner data-testid="spinner-lost-connection" size="sm" />
        ) : (
          <Icon svg={ErrorFillIcon} className="hc8-clr-warning" size="lg" />
        )}
      </CenterAlign>
      <BoldText className="hc8-txt-center hc8-fs-200 hc8-mb-4x">
        Connection Lost
      </BoldText>
      {props.enableReload && reconnectClicked === 2 ? (
        <CenterAlign>
          <>
            <div className="hc8-txt-center hc8-mb-4x">
              <p className="hc8-mb-1x">Still not able to Reconnect?</p>
              <p>Please try to Reload page</p>
            </div>
            <div className="align-centre-centre">
              <Button variant="primary" onClick={handleReloadPage}>
                Reload Page
              </Button>
            </div>
          </>
        </CenterAlign>
      ) : (
        <>
          <div className="hc8-txt-center hc8-mb-4x">
            <p className="hc8-mb-1x">Sorry, your connection has been lost.</p>
            <p>Click on reconnect to retry connection.</p>
          </div>
          <CenterAlign className="display-flex">
            <Button
              variant="primary"
              className="hc8-mb-2x"
              onClick={handleReconnectButton}
            >
              Reconnect
            </Button>
          </CenterAlign>
        </>
      )}
    </LostConnectionPopup>
  )
}

export default LostConnectionPopUp
